import axios from 'axios';
import * as utils from '@/apis/apiUtils';
import type {
  HokkaidoAirportCarCreateOrUpdateParams,
  HokkaidoAirportCarUpdateReportIdParams,
} from '@/models/apis/externalReports/hokkaidoAirport/hokkaidoAirportCarRequest';
import type {
  HokkaidoAirportCarCreateOrUpdateResponse,
  HokkaidoAirportCarShowResponse,
} from '@/models/apis/externalReports/hokkaidoAirport/hokkaidoAirportCarResponse';
import type {
  HokkaidoAirportCar,
  HokkaidoAirportCarShow,
} from '@/models/externalReports/hokkaidoAirport/hokkaidoAirportCar';
import {
  convertHokkaidoAirportReportsResponseToHokkaidoAirportReports,
} from '@/apis/externalReports/hokkaidoAirport/hokkaido_airport_report';

export default {
  async index(): Promise<HokkaidoAirportCarShow[]> {
    const { data } = await axios.get<HokkaidoAirportCarShowResponse[]>(
      utils.getApiUrl('/external_reports/hokkaido-airport/cars'),
    );
    return convertHokkaidoAirportCarShowResponseToHokkaidoAirportCarShow(data);
  },
  async createOrUpdate(params: HokkaidoAirportCarCreateOrUpdateParams): Promise<HokkaidoAirportCar> {
    const { data } = await axios.post<HokkaidoAirportCarCreateOrUpdateResponse>(
      utils.getApiUrl('/external_reports/hokkaido-airport/cars'),
      params,
    );
    return convertHokkaidoAirportCarResponseToHokkaidoAirportCar(data);
  },
  async updateReportId(id: number, params: HokkaidoAirportCarUpdateReportIdParams): Promise<HokkaidoAirportCar> {
    const { data } = await axios.post<HokkaidoAirportCarCreateOrUpdateResponse>(
      utils.getApiUrl(`/external_reports/hokkaido-airport/cars/${id}`),
      params,
    );
    return convertHokkaidoAirportCarResponseToHokkaidoAirportCar(data);
  },
};

function convertHokkaidoAirportCarResponseToHokkaidoAirportCar(
  hokkaidoCar: HokkaidoAirportCarCreateOrUpdateResponse,
): HokkaidoAirportCar {
  return {
    id: hokkaidoCar.id,
    lat: hokkaidoCar.lat,
    lon: hokkaidoCar.lon,
    status: hokkaidoCar.status,
    ts: hokkaidoCar.ts,
    currentReportId: hokkaidoCar.current_report_id,
    userId: hokkaidoCar.user_id,
    statusDisp: hokkaidoCar.status_disp,
  };
}

function convertHokkaidoAirportCarShowResponseToHokkaidoAirportCarShow(
  hokkaidoCars: HokkaidoAirportCarShowResponse[],
): HokkaidoAirportCarShow[] {
  return hokkaidoCars.map(hokkaidoCar => ({
    id: hokkaidoCar.id,
    lat: hokkaidoCar.lat,
    lon: hokkaidoCar.lon,
    status: hokkaidoCar.status,
    ts: hokkaidoCar.ts,
    carName: hokkaidoCar.car_name,
    currentReportId: hokkaidoCar.current_report_id,
    userId: hokkaidoCar.user_id,
    statusDisp: hokkaidoCar.status_disp,
    report: hokkaidoCar.report ? convertHokkaidoAirportReportsResponseToHokkaidoAirportReports(
      [hokkaidoCar.report],
    )[0] : null,
    hanName: hokkaidoCar.han_name,
    tsIsNew: Boolean(hokkaidoCar.ts_is_new),
  }));
}
